import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

export default function DashboardLayouts({ children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  const { isAuthenticated } = useAuth();
  const route = useNavigate();
  const x = useLocation();
  useEffect(() => {
    if (!isAuthenticated && x.pathname !== "/resetpassword") {
      route("/");
    }
  }, [isAuthenticated]);

  useEffect(() => {
    window.addEventListener("resize", () => setIsSidebarOpen(true));
  }, [window.innerWidth]);

  return (
    <>
      <Navbar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      <main className="d-flex align-items-start position-relative">
        <Sidebar isSidebarOpen={isSidebarOpen} />
        <div className="dashboard-main d-flex flex-column px-md-4 px-xxl-5 py-md-3 py-xl-5 overflow-auto flex-grow-1">
          <div className="dashboard-wrapper">{children}</div>
          <footer className="mt-auto">
            <p className="text-center copyright mt-auto pt-3 pt-md-5 pb-3 pb-md-0">
              Copyright @ {new Date().getFullYear()} SCCI
            </p>
          </footer>
        </div>
      </main>
    </>
  );
}
